fragment AvailabilityFragment on Availability {
    id
    times {
        day
        startTime
        endTime
    }
}
